const separator = (price: string | number): string =>
  `${Number(price).toLocaleString()}`;

export default separator;
